// this is used to trick "react-snapshot" into generating this page

import { Component } from "react";

class Game extends Component {
  constructor(props) {
    super(props);
  }
}

export default Game;
